! function ()
{
	"use strict";
	var t = {
			1287: function (t, e, i)
			{
				i.d(e,
				{
					p: function ()
					{
						return r
					}
				});
				var n = i(4662),
					a = i(4739);
				const r = () =>
				{
					const t = document.querySelectorAll('form[data-type="add-to-cart-form"]'),
						e = document.getElementById("main-cart"),
						i = document.getElementById("mini-cart"),
						r = document.querySelector("body");
					t.length && t.forEach(t => t.addEventListener("submit", s =>
					{
						s.preventDefault(), s.stopPropagation(), s.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (s.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`);
						const o = s.target.querySelector('button[type="submit"]'),
							c = o.querySelector("span.cart-icon"),
							l = o.querySelector("svg.loading-icon");
						r.classList.remove("added-to-cart"), o.classList.add("added"), c.style.display = "none", l.style.display = "block";
						const d = (0, n.Dz)("javascript");
						d.headers["X-Requested-With"] = "XMLHttpRequest", delete d.headers["Content-Type"];
						const u = new FormData(t);
						u.append("sections", "main-cart"), d.body = u, fetch(`${routes.cartAdd}`, d).then(t => t.json()).then(async t =>
						{
							if (t.status)
							{
								if (a.A.updateMiniCart(!0), c.style.display = "inline-flex", l.style.display = "none", s.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (s.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`), "object" == typeof t.description) return Object.entries(t.description).forEach(([t, e]) =>
								{
									const i = `${e.join(", ")}`;
									s.target.querySelector(".main-product__error").innerHTML = '<span class="icon loaded">error</span><p>' + i + "</p>"
								});
								s.target.querySelector(".main-product__error").innerHTML = '<span class="icon loaded">error</span><p>' + t.description + "</p>"
							}
							else
							{
								if ("cart" === cartStrings.uxCart) return void(window.location.href = window.routes.cart);
								if (s.target.querySelector(".main-product__error").innerHTML = "", e && e.classList.add("added"), t.sections && null !== t.sections["main-cart"]) a.A.renderItems((new DOMParser).parseFromString(t.sections["main-cart"], "text/html"));
								else
								{
									const t = `${window.location.pathname}?section_id=main-cart`;
									fetch(t).then(t => t.text()).then(t =>
									{
										a.A.renderItems((new DOMParser).parseFromString(t, "text/html"))
									})
								}
								"mini-cart" === cartStrings.uxCart && i && i.open(), s.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (s.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`), o.classList.remove("added"), o.classList.add("successful"), c.style.display = "flex", l.style.display = "none", r.classList.add("added-to-cart")
							}
						}).catch(t =>
						{
							console.error("Error:", t)
						})
					}))
				}
			},
			4662: function (t, e, i)
			{
				i.d(e,
				{
					Dz: function ()
					{
						return n
					},
					jW: function ()
					{
						return a
					},
					qF: function ()
					{
						return o
					},
					sg: function ()
					{
						return r
					}
				});
				const n = (t = "json") => (
					{
						method: "POST",
						headers:
						{
							"Content-Type": "application/json",
							Accept: `application/${t}`
						}
					}),
					a = (t = !1) =>
					{
						const e = window.innerWidth - document.body.offsetWidth,
							i = document.getElementById("nav-wrapper");
						t ? (document.body.classList.add("no-scroll"), document.body.style.paddingRight = e + "px", i.style.paddingRight = e + "px") : (document.body.classList.remove("no-scroll"), document.body.style.paddingRight = "0px", i.style.paddingRight = "0px")
					};

				function r(t, e)
				{
					const i = this;
					let n;
					return function ()
					{
						for (var a = arguments.length, r = new Array(a), s = 0; s < a; s++) r[s] = arguments[s];
						clearTimeout(n), n = setTimeout(function ()
						{
							return t.apply(i, r)
						}, e)
					}
				}
				document.querySelectorAll(".local-scroll").forEach(t =>
				{
					t.addEventListener("click", t =>
					{
						t.preventDefault(), t.stopPropagation();
						const e = t.target.getAttribute("href");
						! function (t, e = 0)
						{
							const i = document.getElementById("nav-wrapper"),
								n = document.querySelector(".header").getAttribute("data-ux-position"),
								a = t.getBoundingClientRect().top;
							window.scrollTo(
							{
								top: "off" !== n ? a + window.scrollY - e + parseFloat(i.style.marginTop) : a + window.scrollY - e,
								behavior: "smooth"
							})
						}(document.querySelector(e))
					})
				});
				const s = {};

				function o(t)
				{
					document.removeEventListener("focusin", s.focusin), document.removeEventListener("focusout", s.focusout), document.removeEventListener("keydown", s.keydown), t && t.focus()
				}
			},
			4739: function (t, e, i)
			{
				var n = i(4662);
				const a = new class
				{
					constructor()
					{
						this.items = Array.from(document.querySelectorAll(".cart-item")), this.items.forEach(t => this.manageState(t)), this.selectorsToUpdate = [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"], this.mainCartSelector = ".shopify-section.cart", this.miniCart = document.getElementById("mini-cart"), this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty", this.parser = new DOMParser
					}
					manageState(t)
					{
						const e = t.getAttribute("data-variant-id");
						t.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", async () =>
						{
							await this.changeCartItem(
							{
								id: e,
								quantity: 0
							}), t.remove()
						});
						const i = t.querySelector('input[name="quantity"]');
						if (!i) return;
						const n = t.querySelector('button[name="plus"]'),
							a = t.querySelector('button[name="minus"]'),
							r = t.querySelector('input[name="quantity"]');
						let s = parseInt(i.value);
						n.addEventListener("click", () =>
						{
							s += 1, i.value = s, this.changeCartItem(
							{
								id: e,
								quantity: s
							})
						}), a.addEventListener("click", () =>
						{
							s -= 1, i.value = s, this.changeCartItem(
							{
								id: e,
								quantity: s
							})
						}), r.addEventListener("change", t =>
						{
							parseInt(t.target.value) > 0 ? (s = parseInt(t.target.value), this.changeCartItem(
							{
								id: e,
								quantity: s
							})) : r.value = s
						}), r.addEventListener("keypress", t =>
						{
							(8 !== t.which && 0 !== t.which && t.which < 48 || t.which > 57) && t.preventDefault()
						})
					}
					async changeCartItem(t)
					{
						const e = {
							...(0, n.Dz)(),
							body: JSON.stringify(
							{
								line: +t.id,
								quantity: t.quantity,
								sections: "main-cart"
							})
						};
						fetch(`${routes.cartChange}`, e).then(t => t.json()).then(t =>
						{
							const e = e =>
							{
								const i = this.parser.parseFromString(e, "text/html");
								if (0 === t.item_count)
								{
									const t = document.querySelector(this.mainCartSelector);
									t && (t.innerHTML = i.querySelector(this.mainCartSelector).innerHTML), this.renderElements(i)
								}
								else this.renderItems(i)
							};
							if (t.sections && null !== t.sections["main-cart"]) e(t.sections["main-cart"]);
							else
							{
								const t = `${window.location.pathname}?section_id=main-cart`;
								fetch(t).then(t => t.text()).then(t =>
								{
									e(t)
								})
							}
							const i = `${window.location.pathname}?section_id=navigation-main`;
							fetch(i).then(t => t.text()).then(e =>
							{
								const i = this.parser.parseFromString(e, "text/html");
								if (0 === t.item_count)
								{
									const t = document.querySelector("#mini-cart");
									t && (t.innerHTML = i.querySelector("#mini-cart").innerHTML, t.addEventListeners(), t.querySelectorAll(".icon").forEach(t => t.classList.add("loaded")))
								}
							})
						}).catch(t =>
						{
							console.error(t)
						})
					}
					renderElements(t)
					{
						this.selectorsToUpdate.forEach(e =>
						{
							try
							{
								const i = document.querySelectorAll(e),
									n = t.querySelector(e);
								i.length && n && i.forEach(t =>
								{
									n.querySelectorAll(".icon").forEach(t => t.classList.add("loaded")), t.replaceWith(n.cloneNode(!0))
								})
							}
							catch (t)
							{
								console.error(`Error updating ${e}`, t)
							}
						});
						const e = t.querySelector(".cart-count");
						document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach(t =>
						{
							e ? (t.classList.contains("visually-hidden") && t.classList.remove("visually-hidden"), t.textContent = e.textContent) : t.classList.add("visually-hidden")
						}), document.querySelector("#cart-open-block .icon").classList.add("loaded")
					}
					renderItems(t)
					{
						this.renderElements(t);
						const e = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
							i = t.querySelector(this.itemsContainersSelector);
						e.forEach(t =>
						{
							t && t.replaceWith(i.cloneNode(!0))
						}), document.querySelectorAll(".cart-item").forEach(t =>
						{
							t.querySelectorAll(".icon").forEach(t => t.classList.add("loaded")), this.manageState(t)
						})
					}
					updateMiniCart(t)
					{
						return fetch("/?section_id=main-cart").then(t => t.text()).then(e =>
						{
							this.renderItems((new DOMParser).parseFromString(e, "text/html")), t && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open()
						}).catch(t =>
						{
							console.error("Error updating mini cart:", t)
						})
					}
				};
				e.A = a, customElements.get("cart-note") || customElements.define("cart-note", class extends HTMLElement
				{
					constructor()
					{
						super(), this.querySelector("textarea").addEventListener("change", (0, n.sg)(t =>
						{
							const e = JSON.stringify(
							{
								note: t.target.value
							});
							fetch(`${routes.cartUpdate}`,
							{
								...(0, n.Dz)(),
								body: e
							})
						}, 300))
					}
				})
			}
		},
		e = {};

	function i(n)
	{
		var a = e[n];
		if (void 0 !== a) return a.exports;
		var r = e[n] = {
			exports:
			{}
		};
		return t[n](r, r.exports, i), r.exports
	}
	i.d = function (t, e)
		{
			for (var n in e) i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n,
			{
				enumerable: !0,
				get: e[n]
			})
		}, i.o = function (t, e)
		{
			return Object.prototype.hasOwnProperty.call(t, e)
		},
		function ()
		{
			var t = i(4662),
				e = i(1287);
			document.addEventListener("DOMContentLoaded", function ()
			{
				document.querySelectorAll(".icon").forEach(t =>
				{
					t.classList.add("loaded")
				}), document.querySelectorAll('a[target="_blank"]').forEach(t =>
				{
					t.innerHTML = t.innerHTML + '<span class="visually-hidden"> ' + accessibilityNoticeNewTab + "</span>"
				}), (0, e.p)()
			}), void 0 !== window.BOOMR && console.log("Built with " + window.BOOMR.themeName + " (https://themes.shopify.com/themes/align/) version " + window.BOOMR.themeVersion + " by Company XYZ (https://companyxyz.io/)."), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function (t, e)
			{
				return function ()
				{
					return t.apply(e, arguments)
				}
			}, Shopify.setSelectorByValue = function (t, e)
			{
				for (var i = 0, n = t.options.length; i < n; i++)
				{
					var a = t.options[i];
					if (e == a.value || e == a.innerHTML) return t.selectedIndex = i, i
				}
			}, Shopify.addListener = function (t, e, i)
			{
				t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i)
			}, Shopify.postLink = function (t, e)
			{
				var i = (e = e ||
					{}).method || "post",
					n = e.parameters ||
					{},
					a = document.createElement("form");
				for (var r in a.setAttribute("method", i), a.setAttribute("action", t), n)
				{
					var s = document.createElement("input");
					s.setAttribute("type", "hidden"), s.setAttribute("name", r), s.setAttribute("value", n[r]), a.appendChild(s)
				}
				document.body.appendChild(a), a.submit(), document.body.removeChild(a)
			}, Shopify.CountryProvinceSelector = function (t, e, i)
			{
				this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(i.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince()
			}, Shopify.CountryProvinceSelector.prototype = {
				initCountry: function ()
				{
					var t = this.countryEl.getAttribute("data-default");
					Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler()
				},
				initProvince: function ()
				{
					var t = this.provinceEl.getAttribute("data-default");
					t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t)
				},
				countryHandler: function (t)
				{
					var e = (a = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
						i = JSON.parse(e);
					if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";
					else
					{
						for (var n = 0; n < i.length; n++)
						{
							var a;
							(a = document.createElement("option")).value = i[n][0], a.innerHTML = i[n][1], this.provinceEl.appendChild(a)
						}
						this.provinceContainer.style.display = ""
					}
				},
				clearOptions: function (t)
				{
					for (; t.firstChild;) t.removeChild(t.firstChild)
				},
				setOptions: function (t, e)
				{
					var i = 0;
					for (e.length; i < e.length; i++)
					{
						var n = document.createElement("option");
						n.value = e[i], n.innerHTML = e[i], t.appendChild(n)
					}
				}
			}, document.querySelectorAll("video").forEach(t =>
			{
				t.muted = !0, new IntersectionObserver(e =>
				{
					e.forEach(e =>
					{
						e.isIntersecting ? 1 == t.autoplay && t.paused && t.play().catch(t =>
						{
							"AbortError" !== t.name && console.error("Error playing video:", t)
						}) : t.pause()
					})
				},
				{
					threshold: 0
				}).observe(t)
			}), document.querySelectorAll("video.hover-play").forEach(t =>
			{
				const e = t.closest(".card");
				t.pause(), e ? (e.addEventListener("mouseenter", () =>
				{
					t.play().catch(t =>
					{
						"AbortError" !== t.name && console.error("Error playing video:", t)
					})
				}), e.addEventListener("mouseleave", () =>
				{
					t.pause()
				})) : (t.addEventListener("mouseenter", () =>
				{
					t.play().catch(t =>
					{
						"AbortError" !== t.name && console.error("Error playing video:", t)
					})
				}), t.addEventListener("mouseleave", () =>
				{
					t.pause()
				}))
			});
			const n = function ()
			{
				[].slice.call(document.querySelectorAll("video")).forEach(t =>
				{
					const e = t.parentElement.querySelector(".figure--video__poster");
					e && e.addEventListener("click", () =>
					{
						e.classList.add("hidden"), t.play()
					})
				});
				var t = [].slice.call(document.querySelectorAll(".figure--video-external"));
				if ("IntersectionObserver" in window)
				{
					var e = new IntersectionObserver(function (t, e)
					{
						t.forEach(function (t)
						{
							if (t.isIntersecting) "vimeo" == t.target.dataset.type && fetch("http://vimeo.com/api/v2/video/" + t.target.dataset.id + ".json").then(t =>
							{
								if (!t.ok) throw new Error(`HTTP error ${t.status}`);
								return t.json()
							}).then(e =>
							{
								t.target.querySelector(".figure--video__external-poster-image").src = e[0].thumbnail_large
							}), t.target.addEventListener("click", function ()
							{
								if (!t.target.querySelector("iframe"))
								{
									let t = this.dataset.type,
										e = document.createElement("iframe");
									e.setAttribute("frameborder", "0"), e.setAttribute("allowfullscreen", ""), e.setAttribute("allow", "autoplay"), "youtube" == t ? (e.setAttribute("id", "youtube"), e.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1")) : e.setAttribute("src", "https://player.vimeo.com/video/" + this.dataset.id + this.dataset.videotags + "rel=0&showinfo=0&autoplay=1"), this.appendChild(e), setTimeout(() =>
									{
										this.querySelector(".figure--video__poster").classList.add("hidden")
									}, 350)
								}
							});
							else if (t.target.querySelector("iframe"))
							{
								let i = t.target.dataset.type,
									n = t.target.querySelectorAll("iframe");
								if ("youtube" == i)
								{
									var e = {
										event: "command",
										func: "pauseVideo"
									};
									n[0].contentWindow.postMessage(JSON.stringify(e), "*")
								}
								else "vimeo" == i && (e = {
									method: "pause",
									value: "true"
								}, n[0].contentWindow.postMessage(JSON.stringify(e), "*"))
							}
						})
					});
					t.forEach(function (t)
					{
						e.observe(t)
					})
				}
			};
			n(), window.addEventListener("beforeprint", () =>
			{
				const t = document.body.querySelectorAll("details"),
					e = document.body.querySelectorAll("img");
				for (let e = 0; e < t.length; e++) t[e].open ? t[e].dataset.open = "1" : t[e].setAttribute("open", "");
				for (let t = 0; t < e.length; t++) e[t].dataset.open = "1"
			}), window.addEventListener("afterprint", () =>
			{
				const t = document.body.querySelectorAll("details");
				for (let e = 0; e < t.length; e++) t[e].dataset.open ? t[e].dataset.open = "" : t[e].removeAttribute("open")
			}), Shopify.designMode && document.addEventListener("shopify:section:load", () =>
			{
				n(), document.querySelectorAll(".icon").forEach(t =>
				{
					t.classList.add("loaded")
				})
			});
			class a extends HTMLElement
			{
				constructor()
				{
					super(), this.addEventListener("change", t =>
					{
						const e = new CustomEvent("variant-update",
						{
							detail:
							{
								event: t,
								section: this.dataset.section,
								product: this.dataset.product,
								block: this.dataset.block
							},
							bubbles: !0
						});
						this.dispatchEvent(e)
					}), document.addEventListener("variant-update", t =>
					{
						this.dataset.section === t.detail.section && this.dataset.product === t.detail.product && this.dataset.block === t.detail.block && (t.detail.event.target.closest("variant-selects") !== this && this.syncSelection(t.detail.event.target), this.onVariantChange())
					}), this.isCardBasedProductForm = null !== this.closest(".card__content")
				}
				connectedCallback()
				{
					this.mainProductUniqueIdentifier = "main-product-" + this.dataset.product, this.uniqueIdentifier = this.dataset.section + "-" + this.dataset.product + (this.dataset.block ? "-" + this.dataset.block : "")
				}
				onVariantChange()
				{
					this.updateOptions(), this.updateMasterId(), this.currentVariant ? (this.updateVariantStatuses(), this.updateImageSwatches(), this.updateMedia(), this.updateURL(), this.updateLinks(), this.renderProductInfo(), this.updateVariantInput(), this.updateAddToCart()) : void 0 === this.currentVariant && this.setUnavailable()
				}
				syncSelection(t)
				{
					const
					{
						name: e,
						value: i
					} = t, n = this.querySelector(`[name="${e}"]`), a = n?.tagName;
					n && ("SELECT" === a ? this.querySelector(`[name="${e}"] [value="${i}"]`).selected = !0 : this.querySelector(`[name="${e}"][value="${i}"]`).checked = !0)
				}
				updateOptions()
				{
					this.options = Array.from(this.querySelectorAll("select, fieldset"), t => "SELECT" === t.tagName ? t.value : "FIELDSET" === t.tagName ? Array.from(t.querySelectorAll("input")).find(t => t.checked)?.value : void 0)
				}
				updateMasterId()
				{
					this.options.includes(void 0) ? this.currentVariant = null : this.currentVariant = this.getVariantData().find(t => !t.options.map((t, e) => this.options[e] === t).includes(!1))
				}
				updateVariantStatuses()
				{
					const t = this.querySelector(":checked").value,
						e = this.getVariantData().filter(e => e.options[0] === t);
					this.getProductVariantSelects().forEach(t =>
					{
						const i = t.querySelectorAll("select, fieldset");
						i.forEach((t, n) =>
						{
							if (0 === n) return;
							const a = t.querySelectorAll('input[type="radio"], option'),
								r = i[n - 1].querySelector(":checked").value,
								s = e.filter(t => t.available && t[`option${n}`] === r).map(t => t[`option${n+1}`]);
							this.setInputAvailability(a, s)
						})
					})
				}
				setInputAvailability(t, e)
				{
					t.forEach(t =>
					{
						const i = t.getAttribute("value"),
							n = e.includes(i);
						"OPTION" === t.tagName && (t.innerText = n ? i : window.productStrings.unavailable_with_option.replace("[value]", i))
					})
				}
				updateImageSwatches()
				{
					this.querySelectorAll("fieldset:has(.image-swatch)").forEach(t =>
					{
						const e = t.dataset.optionPosition,
							i = t.querySelectorAll(".image-swatch");
						for (const t of i)
						{
							const i = [...this.options];
							i[e - 1] = t.value;
							const n = this.getVariantData().find(t => t.options[0] == i[0] && t.options[1] == i[1] && t.options[2] == i[2]);
							if (!n) continue;
							const a = t.labels[0],
								r = a.querySelectorAll("img.variant-image"),
								s = a.querySelector(`img[data-variant-id="${n.id}"]`),
								o = a.querySelector(".image_swatch--text_value");
							r.forEach(t =>
							{
								t.classList.add("hidden")
							}), o.classList.add("u-hide"), s ? s.classList.remove("hidden") : o.classList.remove("u-hide")
						}
					})
				}
				updateMedia()
				{
					if (!this.currentVariant) return;
					if (!this.currentVariant.featured_media) return;
					const t = document.querySelector(`#gallery-${this.uniqueIdentifier}`),
						e = t.dataset.variantStyle;
					if (this.currentVariant.featured_media)
					{
						const i = this.currentVariant.featured_media.id;
						if ("default" == e)
							if (t.swiper.initialized)
							{
								const e = t.swiper.virtual?.slides?.length ? t.swiper.virtual.slides : t.swiper.slides,
									n = Array.from(e).findIndex(t => t.dataset.id == i); - 1 !== n && t.swiper.slideToLoop(n)
							}
						else
						{
							const e = t.querySelector(`[data-id="${i}"]`);
							e && t.prepend(e)
						}
						else if ("variant" == e)
						{
							const e = t.querySelector(`[data-id="${i}"]`);
							e && (t.firstChild.classList.add("u-hide"), e.classList.remove("u-hide"), t.prepend(e))
						}
						const n = document.querySelector(`#sticky-gallery-${this.uniqueIdentifier}`);
						if (n)
						{
							const t = n.querySelectorAll(".sticky-add-to-cart__image"),
								e = this.currentVariant.id;
							t.forEach(t =>
							{
								t.dataset.variantId == e ? t.classList.remove("u-hide") : t.classList.add("u-hide")
							})
						}
					}
				}
				updateURL()
				{
					if ("false" === this.dataset.updateUrl) return;
					const t = `${this.dataset.url}?variant=${this.currentVariant.id}`;
					window.history.replaceState(
					{}, "", t)
				}
				updateLinks()
				{
					if (!this.isCardBasedProductForm) return;
					const t = this.closest(".card__content").querySelector(".button--view-product");
					"A" === t?.tagName && (t.href = this.dataset.url.split("?")[0] + `?variant=${this.currentVariant.id}`)
				}
				updateVariantInput()
				{
					document.querySelectorAll(`#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`).forEach(t =>
					{
						const e = t.querySelector('input[name="id"]');
						e.value = this.currentVariant.id, e.dispatchEvent(new Event("change",
						{
							bubbles: !0
						}))
					})
				}
				renderProductInfo()
				{
					const e = document.getElementById(`price-${this.uniqueIdentifier}`);
					e && (e.classList.contains("price--on-sale") ? e.querySelectorAll(".price__sale .price-item").forEach(t => t.classList.add("skeleton-loading")) : e.querySelector(".price__regular").classList.add("skeleton-loading"));
					const i = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
					i && (i.classList.contains("price--on-sale") ? i.querySelectorAll(".price__sale .price-item").forEach(t => t.classList.add("skeleton-loading")) : i.querySelector(".price__regular").classList.add("skeleton-loading"));
					const n = document.getElementById(`pickup-availability-${this.uniqueIdentifier}`);
					n?.querySelector(".skeleton-loading-wrapper")?.classList.add("skeleton-loading");
					const a = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
					a?.classList.add("skeleton-loading");
					const r = document.getElementById(`pickup-availability-modal-${this.uniqueIdentifier}`);
					fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`).then(t => t.text()).then(s =>
					{
						const o = (new DOMParser).parseFromString(s, "text/html"),
							c = o.getElementById(`price-${this.mainProductUniqueIdentifier}`);
						if (a)
						{
							const t = o.getElementById(`stock-status-${this.mainProductUniqueIdentifier}`);
							t ? (a.classList.remove("u-invisible"), a.innerHTML = t.innerHTML, a.classList = t.classList) : a?.classList.add("u-invisible")
						}
						if (c && e ? (e.classList.remove("u-invisible"), e.innerHTML = c.innerHTML, e.classList = c.classList) : e?.classList.add("u-invisible"), i)
						{
							const t = o.getElementById(`sticky-price-${this.mainProductUniqueIdentifier}`);
							t ? (i.classList.remove("u-invisible"), i.innerHTML = t.innerHTML, i.classList = t.classList) : i?.classList.add("u-invisible")
						}
						if (n)
						{
							const t = o.getElementById(`pickup-availability-${this.mainProductUniqueIdentifier}`);
							t && (n.innerHTML = t.innerHTML, n.classList = t.classList)
						}
						if (r)
						{
							const t = o.getElementById(`pickup-availability-modal-${this.mainProductUniqueIdentifier}`);
							t && (r.innerHTML = t.innerHTML)
						}
						const l = document.querySelector(".pickup-availability"),
							d = document.getElementById("overlay"),
							u = document.getElementById("pickup-availability-open"),
							h = document.getElementById("pickup-availability-close");
						u && document.getElementById("pickup-availability-open").addEventListener("click", function ()
						{
							l.classList.add("open"), d.classList.add("open"), document.body.classList.add("active", "minicart"), (0, t.jW)(!0)
						}), h && document.getElementById("pickup-availability-close").addEventListener("click", function ()
						{
							l.classList.remove("open"), document.body.classList.remove("active", "minicart"), (0, t.jW)(!1), overlay.classList.remove("open", "overlay--all"), (0, t.qF)(l)
						})
					})
				}
				updateAddToCart()
				{
					const t = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`);
					t && (this.currentVariant.available ? t.forEach(t =>
					{
						const e = t.querySelector('[name="add"]'),
							i = t.querySelector('[name="add"] > span:not(.cart-icon)');
						e && (e.removeAttribute("disabled"), i.textContent = `${cartStrings.addToCart}`)
					}) : t.forEach(t =>
					{
						const e = t.querySelector('[name="add"]'),
							i = t.querySelector('[name="add"] > span:not(.cart-icon)');
						e && (e.setAttribute("disabled", "disabled"), i.textContent = `${cartStrings.soldOut}`)
					}))
				}
				setUnavailable()
				{
					const t = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`),
						e = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
					t.forEach(t =>
					{
						const i = t.querySelector('[name="add"]'),
							n = t.querySelector('[name="add"] > span:not(.cart-icon)');
						i && (n.textContent = `${cartStrings.unavailable}`, i.setAttribute("disabled", "disabled"), e && (e.dataset.state = "unavailable"))
					});
					const i = document.getElementById(`price-${this.uniqueIdentifier}`),
						n = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
					i && this.setPriceUnavailable(i), n && this.setPriceUnavailable(n)
				}
				setPriceUnavailable(t)
				{
					t.classList.remove("price--on-sale"), t.classList.add("price--sold-out"), t.querySelector(".price__regular .price-item.price-item--regular").textContent = window.productStrings.price_unavailable
				}
				getVariantData()
				{
					return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
				}
				getProductVariantSelects()
				{
					return document.querySelectorAll(`variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"][data-block="${this.dataset.block}"]`)
				}
			}
			customElements.get("variant-selects") || customElements.define("variant-selects", a);
			// ---- Start custom addition BY: __ARK__
			// const vs = document.querySelector('variant-selects');
			// // This already works because vs is an instance of class 'a'
			// 	document.querySelectorAll('variant-selects').forEach(vs => {
			// 	vs.updateMedia && vs.updateMedia();
			// 	});
			// ---- End custom addition BY: __ARK__
			class r
			{
				constructor(t)
				{
					this.el = t, this.summary = t.querySelector("summary"), this.content = t.querySelector(".content"), this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.summary.addEventListener("click", t => this.onClick(t))
				}
				onClick(t)
				{
					t.preventDefault(), this.el.style.overflow = "hidden", this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink()
				}
				shrink()
				{
					this.isClosing = !0;
					const t = `${this.el.offsetHeight}px`,
						e = `${this.summary.offsetHeight}px`;
					this.animation && this.animation.cancel(), this.animation = this.el.animate(
					{
						height: [t, e]
					},
					{
						duration: 400,
						easing: "ease-out"
					}), this.animation.onfinish = () => this.onAnimationFinish(!1), this.animation.oncancel = () => this.isClosing = !1
				}
				open()
				{
					this.el.style.height = `${this.el.offsetHeight}px`, this.el.open = !0, window.requestAnimationFrame(() => this.expand())
				}
				expand()
				{
					this.isExpanding = !0;
					const t = `${this.el.offsetHeight}px`,
						e = `${this.summary.offsetHeight+this.content.offsetHeight}px`;
					this.animation && this.animation.cancel(), this.animation = this.el.animate(
					{
						height: [t, e]
					},
					{
						duration: 400,
						easing: "ease-out"
					}), this.animation.onfinish = () => this.onAnimationFinish(!0), this.animation.oncancel = () => this.isExpanding = !1
				}
				onAnimationFinish(t)
				{
					this.el.open = t, this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.el.style.height = this.el.style.overflow = ""
				}
			}
			document.querySelectorAll("details.accordion__wrapper").forEach(t =>
			{
				new r(t)
			})
		}()
}();



// ======= ARK_ EXP CODE ==-========
// Minimal custom updateMedia
function quickUpdateMedia() {
  // Get current variant
  const variantId = new URLSearchParams(window.location.search).get('variant') || 
                    document.querySelector('input[name="id"], select[name="id"]')?.value;
  if (!variantId) return;
  
  // Get product data
  const script = document.querySelector('[type="application/json"][data-product-json]');
  if (!script) return;
  
  const productData = JSON.parse(script.textContent);
  const variant = productData.variants.find(v => v.id == variantId);
  if (!variant?.featured_media?.id) return;
  
  const mediaId = variant.featured_media.id;
  
  // Update all galleries
  document.querySelectorAll('.swiper.main-product-gallery, [id^="gallery-"]').forEach(gallery => {
    const variantStyle = gallery.dataset.variantStyle || 'default';
    const targetSlide = gallery.querySelector(`[data-id="${mediaId}"]`);
    
    if (!targetSlide) return;
    
    if (variantStyle === 'variant') {
      // Hide all, show target
      gallery.querySelectorAll('[data-id]').forEach(s => s.classList.add('u-hide'));
      targetSlide.classList.remove('u-hide');
      gallery.prepend(targetSlide);
    } else if (gallery.swiper) {
      // Find slide index and navigate
      const slides = gallery.swiper.slides;
      const index = Array.from(slides).findIndex(s => s.dataset.id == mediaId);
      if (index !== -1) gallery.swiper.slideTo(index);
    }
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(quickUpdateMedia, 300);
  setTimeout(quickUpdateMedia, 1000); // Second try
});




// --------- custom solution JS :BY__ARK__ ---------


document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card__form').forEach(form => {
    const variantSelect = form.querySelector('.variant-dropdown');
    const addToCartBtn = form.querySelector('.product-card__add-to-cart');
    
    // Update button state when variant changes
    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const isAvailable = selectedOption.dataset.available === 'true';
        
        // Update button state
        addToCartBtn.disabled = !isAvailable;
        addToCartBtn.textContent = isAvailable ? 'ADD TO CART' : 'SOLD OUT';
        
        if (!isAvailable) {
          addToCartBtn.classList.add('button--disabled');
        } else {
          addToCartBtn.classList.remove('button--disabled');
        }
      });
    }
    
    // Handle form submission
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const variantId = formData.get('id');
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Added to cart:', data);
      })
      .catch(error => console.error('Error:', error));
    });
  });
});


// ---------STARTS HERE-- Custom Solution For To show the Custom Font on spacial letter/worlds :BY__ARK__ ---------

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card__form').forEach(form => {
    const variantSelect = form.querySelector('.variant-dropdown');
    const addToCartBtn = form.querySelector('.product-card__add-to-cart');
    
    // Update button state when variant changes
    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const isAvailable = selectedOption.dataset.available === 'true';
        
        // Update button state
        addToCartBtn.disabled = !isAvailable;
        addToCartBtn.textContent = isAvailable ? 'ADD TO CART' : 'SOLD OUT';
        
        if (!isAvailable) {
          addToCartBtn.classList.add('button--disabled');
        } else {
          addToCartBtn.classList.remove('button--disabled');
        }
      });
    }
    
    // Handle form submission
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const variantId = formData.get('id');
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Added to cart:', data);
      })
      .catch(error => console.error('Error:', error));
    });
  });
});


function wrapSpecialMarkers() {
  const textContainers = document.querySelectorAll('.rich-text, .rte, [data-section-type="rich-text"], h1,h2,h3');
  
  textContainers.forEach(container => {
    container.innerHTML = container.innerHTML.replace(
      /\*([^*]+)\*/g, 
      '<span class="highlight">$1</span>'
    );
    
    // Or for prefix characters
    container.innerHTML = container.innerHTML.replace(
      /→([^→]+)/g,
      '<span class="highlight-arrow">$1</span>'
    );
  });
}

// Run on page load and on Shopify section loads
document.addEventListener('DOMContentLoaded', wrapSpecialMarkers);
document.addEventListener('shopify:section:load', wrapSpecialMarkers);


document.addEventListener('DOMContentLoaded', function() {
  // Find all swiper-container elements that are inside .grid-no-gap
  const swipers = document.querySelectorAll('.grid-no-gap swiper-container');
  
  swipers.forEach(swiper => {
    if (swiper.shadowRoot) {
      // Create a style element and inject into the shadow root
      const style = document.createElement('style');
      style.textContent = `
        .swiper-wrapper {
          gap: 0 !important;
        }
      `;
      swiper.shadowRoot.appendChild(style);
    }
  });
});


// Run after DOM ready
document.addEventListener('DOMContentLoaded', function() {
  injectStylesIntoAllShadowRoots('.grid-no-gap swiper-container a', `
    border-radius: 0 !important;
  `);
});

// ---------ENDS HERE-- Custom Solution For To show the Custom Font on spacial letter/worlds :BY__ARK__ ---------